import useAppSelector from "./useAppSelector";

const useUrl = () => {
    const { adminPrefix } = useAppSelector(state => state.config);
    const _URLS = {
        // Login
        _URL_LOGIN: `login.html`,

        _URL_PROFILE: `profile.html`,

        // Dashboard
        _URL_DASHBOARD: `dashboard.html`,

        // Locale
        _URL_LOCALE: `locale.html`,
        "_URL_LOCALE.CREATE": `locale/create.html`,
        "_URL_LOCALE.EDIT": `locale/update/:id.html`,
        "_URL_LOCALE.TRANSLATE": `locale/translate/:id.html`,

        // Role
        _URL_ROLE: `role.html`,
        "_URL_ROLE.CREATE": `role/create.html`,
        "_URL_ROLE.EDIT": `role/update/:id.html`,
        "_URL_ROLE.ACCESS_CONTROL.PERMISSION": `role/access-control/:id.html`,
        "_URL_ROLE.ACCESS_CONTROL.FORM": `role/access-control/form/:roleId.html`,

        // Permission
        _URL_PERMISSION: `permission.html`,
        "_URL_PERMISSION.CREATE": `permission/create.html`,
        "_URL_PERMISSION.EDIT": `permission/update/:id.html`,

        // Menu
        _URL_MENU: `menu.html`,
        "_URL_MENU.CREATE": `menu/create.html`,
        "_URL_MENU.EDIT": `menu/update/:id.html`,

        // User
        _URL_USER: `user.html`,
        "_URL_USER.CREATE": `user/create.html`,
        "_URL_USER.EDIT": `user/update/:id.html`,
        "_URL_USER.ACCESS_CONTROL.PERMISSION": `user/access-control/:id.html`,
        "_URL_USER.ACCESS_CONTROL.FORM": `user/access-control/form/:userId.html`,

        // Group User
        _URL_GROUP_USER: `group-user.html`,
        "_URL_GROUP_USER.CREATE": `group-user/create.html`,
        "_URL_GROUP_USER.EDIT": `group-user/update/:id.html`,
        "_URL_GROUP_USER.USERS": `group-user/users/:id.html`,
        "_URL_GROUP_USER.ACCESS_CONTROL.PERMISSION": `group-user/access-control/:id.html`,
        "_URL_GROUP_USER.ACCESS_CONTROL.FORM": `group-user/access-control/form/:groupId.html`,

        // Library
        _URL_LIBRARY: `library.html`,
        "_URL_LIBRARY.CREATE": `library/create.html`,
        "_URL_LIBRARY.EDIT": `library/update/:id.html`,

        // Config
        _URL_CONFIG: `config.html`,
        "_URL_CONFIG.CREATE": `config/create.html`,
        "_URL_CONFIG.EDIT": `config/update/:id.html`,

        // Status
        _URL_STATUS: `status.html`,
        "_URL_STATUS.CREATE": `status/create.html`,
        "_URL_STATUS.EDIT": `status/update/:id.html`,

        // Workflow
        _URL_WORKFLOW: `workflow.html`,
        "_URL_WORKFLOW.CREATE": `workflow/create.html`,
        "_URL_WORKFLOW.EDIT": `workflow/update/:id.html`,
        "_URL_WORKFLOW.PROCESS_FLOW": `workflow/process-flow/:workflowId.html`,
        "_URL_WORKFLOW.STEP": `workflow/step/:workflowId.html`,
        "_URL_WORKFLOW.STEP.CREATE": `workflow/step/:workflowId/create.html`,
        "_URL_WORKFLOW.STEP.EDIT": `workflow/step/:workflowId/update/:id.html`,


        // Form
        _URL_FORM: `form.html`,
        "_URL_FORM.CREATE": `form/create.html`,
        "_URL_FORM.EDIT": `form/update/:id.html`,
        "_URL_FORM.STEP": `form/:id/step.html`,
        "_URL_FORM.STEP.CONFIG": `form/:formId/step/config/:stepId.html`,
        "_URL_FORM.STATUS": `form/:id/status.html`,
        "_URL_FORM.BUILDER": `form/builder/:id.html`,

        // Module
        _URL_MODULE: `module.html`,
        "_URL_MODULE.CREATE": `module/create.html`,
        "_URL_MODULE.EDIT": `module/update/:id.html`,

        // Layout
        _URL_LAYOUT: `layout.html`,
        "_URL_LAYOUT.CREATE": `layout/create.html`,
        "_URL_LAYOUT.EDIT": `layout/update/:id.html`,

        // Page
        _URL_PAGE: `page.html`,
        "_URL_PAGE.CREATE": `page/create.html`,
        "_URL_PAGE.EDIT": `page/update/:id.html`,
        "_URL_PAGE.BUILDER": `page/builder/:id.html`,
        "_URL_PAGE.BUILDER.PREVIEW": `page/builder/preview-page.html`,

        // Data
        "_URL_DATA": `data/:formCode.html`,
        "_URL_DATA.STEP": `data/:formCode/:stepName/:stepId.html`,
        "_URL_DATA.STEP.ID": `data/:formCode/:stepName/:stepId/:id.html`,

    } as const;

    const URLS = {
        // Login
        URL_LOGIN: `${adminPrefix}/${_URLS._URL_LOGIN}`,

        URL_PROFILE: `${adminPrefix}/${_URLS._URL_PROFILE}`,

        // Dashboard
        URL_DASHBOARD: `${adminPrefix}/${_URLS._URL_DASHBOARD}`,

        // Locale
        URL_LOCALE: `${adminPrefix}/${_URLS._URL_LOCALE}`,
        "URL_LOCALE.CREATE": `${adminPrefix}/${_URLS["_URL_LOCALE.CREATE"]}`,
        "URL_LOCALE.EDIT": `${adminPrefix}/${_URLS["_URL_LOCALE.EDIT"]}`,
        "URL_LOCALE.TRANSLATE": `${adminPrefix}/${_URLS["_URL_LOCALE.TRANSLATE"]}`,

        // Role
        URL_ROLE: `${adminPrefix}/${_URLS._URL_ROLE}`,
        "URL_ROLE.CREATE": `${adminPrefix}/${_URLS["_URL_ROLE.CREATE"]}`,
        "URL_ROLE.EDIT": `${adminPrefix}/${_URLS["_URL_ROLE.EDIT"]}`,
        "URL_ROLE.ACCESS_CONTROL.PERMISSION": `${adminPrefix}/${_URLS["_URL_ROLE.ACCESS_CONTROL.PERMISSION"]}`,
        "URL_ROLE.ACCESS_CONTROL.FORM": `${adminPrefix}/${_URLS["_URL_ROLE.ACCESS_CONTROL.FORM"]}`,

        // Permission
        URL_PERMISSION: `${adminPrefix}/${_URLS._URL_PERMISSION}`,
        "URL_PERMISSION.CREATE": `${adminPrefix}/${_URLS["_URL_PERMISSION.CREATE"]}`,
        "URL_PERMISSION.EDIT": `${adminPrefix}/${_URLS["_URL_PERMISSION.EDIT"]}`,

        // Menu
        URL_MENU: `${adminPrefix}/${_URLS._URL_MENU}`,
        "URL_MENU.CREATE": `${adminPrefix}/${_URLS["_URL_MENU.CREATE"]}`,
        "URL_MENU.EDIT": `${adminPrefix}/${_URLS["_URL_MENU.EDIT"]}`,

        // User
        URL_USER: `${adminPrefix}/${_URLS._URL_USER}`,
        "URL_USER.CREATE": `${adminPrefix}/${_URLS["_URL_USER.CREATE"]}`,
        "URL_USER.EDIT": `${adminPrefix}/${_URLS["_URL_USER.EDIT"]}`,
        "URL_USER.ACCESS_CONTROL.PERMISSION": `${adminPrefix}/${_URLS["_URL_USER.ACCESS_CONTROL.PERMISSION"]}`,
        "URL_USER.ACCESS_CONTROL.FORM": `${adminPrefix}/${_URLS["_URL_USER.ACCESS_CONTROL.FORM"]}`,

        // Group User
        URL_GROUP_USER: `${adminPrefix}/${_URLS._URL_GROUP_USER}`,
        "URL_GROUP_USER.CREATE": `${adminPrefix}/${_URLS["_URL_GROUP_USER.CREATE"]}`,
        "URL_GROUP_USER.EDIT": `${adminPrefix}/${_URLS["_URL_GROUP_USER.EDIT"]}`,
        "URL_GROUP_USER.USERS": `${adminPrefix}/${_URLS["_URL_GROUP_USER.USERS"]}`,
        "URL_GROUP_USER.ACCESS_CONTROL.PERMISSION": `${adminPrefix}/${_URLS["_URL_GROUP_USER.ACCESS_CONTROL.PERMISSION"]}`,
        "URL_GROUP_USER.ACCESS_CONTROL.FORM": `${adminPrefix}/${_URLS["_URL_GROUP_USER.ACCESS_CONTROL.FORM"]}`,

        // Library
        URL_LIBRARY: `${adminPrefix}/${_URLS._URL_LIBRARY}`,
        "URL_LIBRARY.CREATE": `${adminPrefix}/${_URLS["_URL_LIBRARY.CREATE"]}`,
        "URL_LIBRARY.EDIT": `${adminPrefix}/${_URLS["_URL_LIBRARY.EDIT"]}`,

        // Config
        URL_CONFIG: `${adminPrefix}/${_URLS._URL_CONFIG}`,
        "URL_CONFIG.CREATE": `${adminPrefix}/${_URLS["_URL_CONFIG.CREATE"]}`,
        "URL_CONFIG.EDIT": `${adminPrefix}/${_URLS["_URL_CONFIG.EDIT"]}`,

        // Status
        URL_STATUS: `${adminPrefix}/${_URLS._URL_STATUS}`,
        "URL_STATUS.CREATE": `${adminPrefix}/${_URLS["_URL_STATUS.CREATE"]}`,
        "URL_STATUS.EDIT": `${adminPrefix}/${_URLS["_URL_STATUS.EDIT"]}`,

        // Workflow
        URL_WORKFLOW: `${adminPrefix}/${_URLS._URL_WORKFLOW}`,
        "URL_WORKFLOW.CREATE": `${adminPrefix}/${_URLS["_URL_WORKFLOW.CREATE"]}`,
        "URL_WORKFLOW.EDIT": `${adminPrefix}/${_URLS["_URL_WORKFLOW.EDIT"]}`,

        "URL_WORKFLOW.PROCESS_FLOW": `${adminPrefix}/${_URLS["_URL_WORKFLOW.PROCESS_FLOW"]}`,
        "URL_WORKFLOW.STEP": `${adminPrefix}/${_URLS["_URL_WORKFLOW.STEP"]}`,
        "URL_WORKFLOW.STEP.CREATE": `${adminPrefix}/${_URLS["_URL_WORKFLOW.STEP.CREATE"]}`,
        "URL_WORKFLOW.STEP.EDIT": `${adminPrefix}/${_URLS["_URL_WORKFLOW.STEP.EDIT"]}`,

        // Form
        URL_FORM: `${adminPrefix}/${_URLS._URL_FORM}`,
        "URL_FORM.CREATE": `${adminPrefix}/${_URLS["_URL_FORM.CREATE"]}`,
        "URL_FORM.EDIT": `${adminPrefix}/${_URLS["_URL_FORM.EDIT"]}`,
        "URL_FORM.STEP": `${adminPrefix}/${_URLS["_URL_FORM.STEP"]}`,
        "URL_FORM.STEP.CONFIG": `${adminPrefix}/${_URLS["_URL_FORM.STEP.CONFIG"]}`,
        "URL_FORM.STATUS": `${adminPrefix}/${_URLS["_URL_FORM.STATUS"]}`,
        "URL_FORM.BUILDER": `${adminPrefix}/${_URLS["_URL_FORM.BUILDER"]}`,

        // Module
        URL_MODULE: `${adminPrefix}/${_URLS._URL_MODULE}`,
        "URL_MODULE.CREATE": `${adminPrefix}/${_URLS["_URL_MODULE.CREATE"]}`,
        "URL_MODULE.EDIT": `${adminPrefix}/${_URLS["_URL_MODULE.EDIT"]}`,

        // Layout
        URL_LAYOUT: `${adminPrefix}/${_URLS._URL_LAYOUT}`,
        "URL_LAYOUT.CREATE": `${adminPrefix}/${_URLS["_URL_LAYOUT.CREATE"]}`,
        "URL_LAYOUT.EDIT": `${adminPrefix}/${_URLS["_URL_LAYOUT.EDIT"]}`,

        // Page
        URL_PAGE: `${adminPrefix}/${_URLS._URL_PAGE}`,
        "URL_PAGE.CREATE": `${adminPrefix}/${_URLS["_URL_PAGE.CREATE"]}`,
        "URL_PAGE.EDIT": `${adminPrefix}/${_URLS["_URL_PAGE.EDIT"]}`,
        "URL_PAGE.BUILDER": `${adminPrefix}/${_URLS["_URL_PAGE.BUILDER"]}`,
        "URL_PAGE.BUILDER.PREVIEW": `${adminPrefix}/${_URLS["_URL_PAGE.BUILDER.PREVIEW"]}`,

        // Data
        "URL_DATA": `${adminPrefix}/${_URLS["_URL_DATA"]}`,
        "URL_DATA.STEP": `${adminPrefix}/${_URLS["_URL_DATA.STEP"]}`,
        "URL_DATA.STEP.ID": `${adminPrefix}/${_URLS["_URL_DATA.STEP.ID"]}`,
    } as const;
    type UrlKey = keyof typeof URLS;

    type ExtractParams<T extends string> =
        T extends `${string}:${infer Param}/${infer Rest}`
        ? Param | ExtractParams<Rest>
        : T extends `${string}:${infer Param}.${string}`
        ? Param
        : T extends `${string}:${infer Param}`
        ? Param
        : never;

    type UrlParams<K extends UrlKey> =
        ExtractParams<(typeof URLS)[K]> extends never
        ? undefined
        : {
            [P in ExtractParams<(typeof URLS)[K]>]: string | number;
        };

    type UrlArgs<K extends UrlKey> =
        UrlParams<K> extends undefined
        ? []
        : [params: UrlParams<K>];

    const url = <K extends UrlKey>(
        key: K,
        ...args: UrlArgs<K>
    ) => {
        let path = URLS[key] as string;

        const params = args[0];

        if (params) {
            Object.entries(params).forEach(([key, value]) => {
                path = path.replace(`:${key}`, String(value));
            });
        }

        return path;
    };

    return {
        adminPrefix,
        urls: { ..._URLS, ...URLS },
        url,
    };
};

export default useUrl;